import { format,parse,differenceInSeconds } from 'date-fns';
import { DriveScheduleItem } from "./drive.schedule.item";
import { DriveScheduleTrip } from "./drive.schedule.trip";
import { DriveScheduleRest } from "./drive.schedule.rest";

export class DriveScheduleRow {
    id:any = 0;
    dtgUnitId:string = "";
    dtgRegDt:string = "";
    dtgRegDtYy:number = 0;
    dtgRegDtMm:number = 0;
    dtgRegDtDd:number = 0;
    dtgRegDtHh:number = 0;
    dtgRegDtFrom:string = "";
    dtgRegDtTo:string = "";
    dtgCarNo:string = "";
    dtgCarType:string = "";
    dtgCarTypeNm:string = "";
    userId:string = "";
    userNm:string = "";
    userBirthDt:string = "";
    userHireDt:string = "";
    companyId:string = "";
    companyNm:string = "";
    dtgEid:string = "";
    tid:string = "";
    ccd:string = "";
    teamId:string = "";
    drivePathNm:string = "";
    drivePathFromNm:string = "";
    drivePathToNm:string = "";
    drvKotsaDriverId:string = "";
    listSchedule:DriveScheduleItem[] = [];
    listTrip:DriveScheduleTrip[] = [];
    listRest:DriveScheduleRest[] = [];
    limitMinuteTrip:number = 10;//10분 미만 제외
    limitMinuteRest:number = 5;//5분 미만 제외
    err:any = {};
    msg:any = {};
    import(resItem){
        for(let key1 in resItem){
            if(this.hasOwnProperty(key1) === true){
                this[key1] = resItem[key1];
            }
        }
    };
    getDtFromRowDate(){
        return parse(this.dtgRegDtFrom,"yyyy-MM-dd HH:mm:ss",new Date());//배차시작
    };
    getDtToRowDate(){
        return parse(this.dtgRegDtTo,"yyyy-MM-dd HH:mm:ss",new Date());//배차종료
    };
    getDtFromRowTxt(){
        if(this.getItemTripMin()){
            return this.getItemTripMin().getDtFromTripTxt();
        }
        if(this.getItemScheduleMin()){
            return this.getItemScheduleMin().getDtFromScheduleTxt();
        }
        return this.dtgRegDtFrom;
    };
    getDtToRowTxt(){
        if(this.getItemTripMax()){
            return this.getItemTripMax().getDtToTripTxt();
        }
        if(this.getItemScheduleMax()){
            return this.getItemScheduleMax().getDtToScheduleTxt();
        }
        return this.dtgRegDtTo;
    }
    getDtFromRowTxtDisplay(){
        return this.dtgRegDtFrom;
    };
    sortSchedule(orderType:string = "asc"){
        if(this.listSchedule){
            this.listSchedule.sort((itemA,itemB) => {
                switch(orderType){
                    case "desc":
                        return itemB.getDtFromScheduleDate().getTime() - itemA.getDtFromScheduleDate().getTime();
                    default:
                        return itemA.getDtFromScheduleDate().getTime() - itemB.getDtFromScheduleDate().getTime();
                }
            });
            this.updateDtFromWithItemSchedule();
            this.updateDtToWithItemSchedule();
        }
    };
    getItemScheduleMin(){
        let item:DriveScheduleItem = null;
        if(this.listSchedule){
            item = this.listSchedule[0];
        }
        return item;
    }
    getItemScheduleMax(){
        let item:DriveScheduleItem = null;
        if(this.listSchedule){
            item = this.listSchedule[this.listSchedule.length - 1];
        }
        return item;
    }
    updateDtFromWithItemSchedule(){
        let scheduleMin = this.getItemScheduleMin();
        if(scheduleMin){
            this.dtgRegDtFrom = scheduleMin.dtgRegDtFrom;
        }
    }
    updateDtToWithItemSchedule(){
        let scheduleMax = this.getItemScheduleMax();
        if(scheduleMax){
            this.dtgRegDtTo = scheduleMax.dtgRegDtTo;
        }
    }
    addItemTrip(idxRow:number,itemTrip:DriveScheduleTrip){
        if(itemTrip){
            if(this.dtgUnitId === itemTrip.dtgUnitId){
                if(this.listSchedule){
                    let sizeListSchedule = this.listSchedule.length;
                    // 배차 시간에 맞춰서 운행시간을 조절
                    for(let c=0;c<sizeListSchedule;c++){
                        let itemSchedule:DriveScheduleItem = this.listSchedule[c];// row split item
                        // 배차정보 : 누가,어느차량을,언제부터,언제까지 (어느차량을 + 언제부터 unique key)
                        let dtFromSchedule = itemSchedule.getDtFromScheduleDate();//배차시작
                        let dtToSchedule = itemSchedule.getDtToScheduleDate();//배차종료
                        let dtFromTrip = itemTrip.getDtFromTripDate();//운행시작
                        let dtToTrip = itemTrip.getDtToTripDate();//운행종료

                        // 배차 범위에 운행이 있을 때
                        if(dtFromTrip.getTime() >= dtFromSchedule.getTime() && dtFromTrip.getTime() <= dtToSchedule.getTime()){
                            // 운행 시작이 배차 시작<->종료에 포함될때
                            itemTrip.idxRow = idxRow;//어느 행인지
                            itemTrip.idxSchedule = c;//어느 배차정보에 포함되는지
                            itemTrip.idRow = this.id;
                            itemTrip.idSchedule = itemSchedule.id;
                            if(dtToTrip.getTime() >= dtToSchedule.getTime()){
                                // 운행 종료가 배차 종료보다 크면 운행 종료는 배차 종료로 변경
                                // itemTrip.dtToTrip = itemSchedule.dtgRegDtTo;
                                // itemTrip.dtFromRest = itemSchedule.dtgRegDtTo;
                                itemTrip.setDtToTrip(itemSchedule.dtgRegDtTo);
                            }
                            this.listTrip.push(itemTrip);
                            continue;
                        }
                        if(dtToTrip.getTime() >= dtFromSchedule.getTime() && dtToTrip.getTime() <= dtToSchedule.getTime()){
                            // 운행 종료가 배차 시작<->종료에 포함될때
                            itemTrip.idxRow = idxRow;//어느 행인지
                            itemTrip.idxSchedule = c;//어느 배차정보에 포함되는지
                            itemTrip.idRow = this.id;
                            itemTrip.idSchedule = itemSchedule.id;
                            if(dtFromTrip.getTime() <= dtFromSchedule.getTime()){
                                // 운행 시작이 배차 시작보다 작으면 운행 시작은 배차 시작으로 변경
                                itemTrip.dtFromTrip = itemSchedule.dtgRegDtFrom;
                            }
                            this.listTrip.push(itemTrip);
                            continue;
                        }

                        // 운행 범위 안에 배차가 있을 때
                        if(dtFromSchedule.getTime() >= dtFromTrip.getTime() && dtFromSchedule.getTime() <= dtToTrip.getTime()){
                            // 배차 시작이 운행 시작<->종료에 포함될때
                            itemTrip.idxRow = idxRow;//어느 행인지
                            itemTrip.idxSchedule = c;//어느 배차정보에 포함되는지
                            itemTrip.idRow = this.id;
                            itemTrip.idSchedule = itemSchedule.id;
                            itemTrip.dtFromTrip = itemSchedule.dtgRegDtFrom;//운행 시작은 배차 시작으로 변경
                            if(dtToTrip.getTime() >= dtToSchedule.getTime()){
                                // 운행 종료가 배차 종료보다 크면 운행 종료는 배차 종료로 변경
                                // itemTrip.dtToTrip = itemSchedule.dtgRegDtTo;
                                // itemTrip.dtFromRest = itemSchedule.dtgRegDtTo;
                                itemTrip.setDtToTrip(itemSchedule.dtgRegDtTo);
                            }
                            this.listTrip.push(itemTrip);
                            continue;
                        }
                        if(dtToSchedule.getTime() >= dtFromTrip.getTime() && dtToSchedule.getTime() <= dtToTrip.getTime()){
                            // 배차 종료가 운행 시작<->종료에 포함될때
                            itemTrip.idxRow = idxRow;//어느 행인지
                            itemTrip.idxSchedule = c;//어느 배차정보에 포함되는지
                            itemTrip.idRow = this.id;
                            itemTrip.idSchedule = itemSchedule.id;
                            // itemTrip.dtToTrip = itemSchedule.dtgRegDtTo;//운행 종료는 배차 종료로 변경
                            // itemTrip.dtFromRest = itemSchedule.dtgRegDtTo;
                            itemTrip.setDtToTrip(itemSchedule.dtgRegDtTo);
                            if(dtFromTrip.getTime() <= dtFromSchedule.getTime()){
                                // 운행 시작이 배차 시작보다 작으면 운행 시작은 배차 시작으로 변경
                                itemTrip.dtFromTrip = itemSchedule.dtgRegDtFrom;
                            }
                            this.listTrip.push(itemTrip);
                            continue;
                        }
                    }
                }
            }
        }
    }
    sortTrip(orderType:string = "asc"){
        if(this.listTrip){
            this.listTrip.sort((itemA,itemB) => {
                switch(orderType){
                    case "desc":
                        return itemB.getDtFromTripDate().getTime() - itemA.getDtFromTripDate().getTime();
                    default:
                        return itemA.getDtFromTripDate().getTime() - itemB.getDtFromTripDate().getTime();
                }
            });
            this.updateDtFromScheduleWithTrip();
            this.updateDtToScheduleWithTrip();
        }
    };
    getItemTripMin(){
        let item:DriveScheduleTrip = null;
        if(this.listTrip){
            item = this.listTrip[0];
        }
        return item;
    }
    getItemTripMax(){
        let item:DriveScheduleTrip = null;
        if(this.listTrip){
            item = this.listTrip[this.listTrip.length - 1];
        }
        return item;
    }
    updateDtFromScheduleWithTrip(){
        let minItem = this.getItemTripMin();
        if(minItem){
            let itemSchedule = this.listSchedule[minItem.idxSchedule];
            itemSchedule.dtgRegDtFrom = minItem.dtFromTrip;
            this.updateDtFromWithItemSchedule();
        }
    }
    updateDtToScheduleWithTrip(){
        let maxItem = this.getItemTripMax();
        if(maxItem){
            let itemSchedule = this.listSchedule[maxItem.idxSchedule];
            itemSchedule.dtgRegDtTo = maxItem.dtToTrip;
            this.updateDtToWithItemSchedule();
        }
    }
    // idxCnt = 회차 index
    getDurMinuteTrip(idxCnt:number = 0){
        let dur = 0;
        if(this.listTrip){
            let itemTrip = this.listTrip[idxCnt];
            if(itemTrip){
                dur = itemTrip.getDurMinuteTrip();
            }
        }
        return dur;
    }
    getDurMinuteRest(idxCnt:number = 0){
        let dur = 0;
        if(this.listTrip){
            let itemTrip = this.listTrip[idxCnt];
            if(itemTrip){
                dur = itemTrip.getDurMinuteRest();
            }
        }
        return dur;
    }
    getTxtTrip(idxCnt:number = 0){
        let txt = "";
        if(this.listTrip){
            let itemTrip = this.listTrip[idxCnt];
            if(itemTrip){
                let txtFromTrip = itemTrip.dtFromTrip;
                let txtToTrip = itemTrip.dtToTrip;
                txt = `${txtFromTrip} - ${txtToTrip}`;
            }
        }
        return txt;
    }
    getTxtSchedule(idxCnt:number = 0){
        let txt = "";
        if(this.listTrip){
            let itemTrip = this.listTrip[idxCnt];
            if(itemTrip){
                let scheduleItemId = itemTrip.idxSchedule;
                let itemSchedule = this.listSchedule[scheduleItemId];
                let txtFromSchedule = itemSchedule.dtgRegDtFrom;
                let txtToSchedule = itemSchedule.dtgRegDtTo;
                txt = `${txtFromSchedule} - ${txtToSchedule}`;
            }
        }
        return txt;
    }
    getTxtRest(idxCnt:number = 0){
        let txt = "";
        if(this.listTrip){
            let itemTrip = this.listTrip[idxCnt];
            if(itemTrip){
                let txtFromRest = itemTrip.dtFromRest;
                let txtToRest = itemTrip.dtToRest;
                txt = `${txtFromRest} - ${txtToRest}`;
            }
        }
        return txt;
    }
    addItemRest(idxRow:number,itemRest:DriveScheduleRest){
        if(itemRest){
            if(this.dtgUnitId === itemRest.dtgUnitId){
                if(this.listTrip){
                    let sizeListTrip = this.listTrip.length;
                    for(let a=0;a<sizeListTrip;a++){
                        let itemTrip = this.listTrip[a];
                        let dtFromTrip = itemTrip.getDtFromTripDate();//운행시작
                        let dtToTrip = itemTrip.getDtToTripDate();//운행종료
                        let dtFromRest = itemRest.getDtFromRestDate();//휴식시작
                        // let dtToRest = itemRest.getDtToRestDate();//휴식종료
                        if(dtFromRest.getTime() >= dtFromTrip.getTime() && dtFromRest.getTime() <= dtToTrip.getTime()){
                            // 휴식 시작이 운행 시작<->종료에 포함될때
                            this.listRest.push(itemRest);
                            let newItemTripPre = new DriveScheduleTrip();//분리 한 운행의 앞부분 (운행시작 <-> 휴식시작)
                            newItemTripPre.import(itemTrip);
                            newItemTripPre.dtToTrip = itemRest.dtFromRest;
                            newItemTripPre.dtFromRest = itemRest.dtFromRest;
                            newItemTripPre.dtToRest = itemRest.dtToRest;
                            itemTrip.dtFromTrip = itemRest.dtToRest;//뒷 부분의 시작은 휴식의 종료
                            this.listTrip.splice(a,0,newItemTripPre);// 일단 리스트에 포함시킨다
                            continue;
                        }
                    }
                }
            }
        }
    }
    updateDtTrip(){
        let promise = new Promise<void>((resolve) => {
            if(this.listSchedule){
                let sizelistSchedule = this.listSchedule.length;
                for(let a=0;a<sizelistSchedule;a++){
                    let itemSchedule:DriveScheduleItem = this.listSchedule[a];
                    if(this.listTrip && this.listTrip.length > 1){
                        let sizeListTrip = this.listTrip.length;
                        let itemTripMin:DriveScheduleTrip = null;
                        let itemTripMax:DriveScheduleTrip = null;
                        for(let b=0;b<sizeListTrip;b++){
                            let itemTrip:DriveScheduleTrip = this.listTrip[b];
                            if(itemTrip.idxSchedule === a){
                                if(!itemTripMin){
                                    itemTripMin = itemTrip;
                                }
                                if(!itemTripMax){
                                    itemTripMax = itemTrip;
                                }
                                let dtFromDrive = itemTrip.getDtFromTripDate();//운행시작
                                let dtToDrive = itemTrip.getDtToTripDate();//운행종료
                                if(dtFromDrive.getTime() <= itemTripMin.getDtFromTripDate().getTime()){
                                    itemTripMin = itemTrip;
                                }
                                if(dtToDrive.getTime() >= itemTripMax.getDtToTripDate().getTime()){
                                    itemTripMax = itemTrip;
                                }
                            }
                        }
    
                        if(itemTripMin.getDtFromTripDate().getTime() >= itemSchedule.getDtFromScheduleDate().getTime()){
                            // 배차 시작보다 최소 운행 시작이 크면 배차 시작을 운행 시작으로 변경
                            itemSchedule.dtgRegDtFrom = itemTripMin.dtFromTrip;
                        }
                        if(itemTripMax.getDtToTripDate().getTime() <= itemSchedule.getDtToScheduleDate().getTime()){
                            // 배차 종료보다 최대 운행 시작이 작으면 배차 종료를 운행 종료로 변경
                            itemSchedule.dtgRegDtTo = itemTripMax.dtToTrip;
                        }
                    }
                }
            }
            resolve();
        });
        return promise;
    }
    updateDtRest(){
        let promise = new Promise<void>((resolve) => {
            if(this.listTrip){
                let sizeListTrip = this.listTrip.length;
                for(let a=0;a<sizeListTrip - 1;a++){
                    let itemTripCurr = this.listTrip[a];
                    let itemTripNext = this.listTrip[a + 1];
                    itemTripCurr.dtFromRest = itemTripCurr.dtToTrip;
                    itemTripCurr.dtToRest = itemTripNext.dtFromTrip;
                }
            }
            resolve();
        });
        return promise;
    }
    reRangeMinRest(){
        let promise = new Promise<void>((resolve) => {
            if(this.listTrip && this.listTrip.length > 1){
                let idxTrip = 0;
                while(idxTrip < this.listTrip.length - 1){
                    let itemTripCurr = this.listTrip[idxTrip];// col
                    // console.log("reRangeMinRest",a,idxTrip);
                    let durRest = itemTripCurr.getDurMinuteRest();
    
                    // 선택한 제외시간 보다 작은 아이템은 제거
                    if(durRest < this.limitMinuteRest || durRest === 0) {
                        let idxTripNext = idxTrip + 1;
                        if(idxTripNext < this.listTrip.length){
                            // 마지막 직전까지만
                            let itemTripNext = this.listTrip[idxTripNext];
                            // console.log("reRangeMinRest","curr",itemTripCurr);
                            // console.log("reRangeMinRest","next",itemTripNext);
                            // console.log("reRangeMinRest",listTrip.length);
                            // 다음 주행 시작시간을 현재 시작 시간으로
                            itemTripNext.dtFromTrip = itemTripCurr.dtFromTrip;
                            // 현재 운행정보 제거
                            this.listTrip.splice(idxTrip,1);
                            // console.log("reRangeMinRest",listTrip.length);
                            continue;
                        }
                    }
                    idxTrip++;
                }
            }
            resolve();
        });
        return promise;
    }
    reRangeMinDrive(){
        let promise = new Promise<void>((resolve) => {
            if(this.listTrip && this.listTrip.length > 1){
                let idxTrip = this.listTrip.length - 1;//마지막 아이템부터 시작
                while(idxTrip >= 0){
                    let itemTripCurr = this.listTrip[idxTrip];// col
                    // console.log("reRangeMinDrive",a,idxTrip);
                    let durTrip = itemTripCurr.getDurMinuteTrip();

                    // 선택한 제외시간 보다 작은 아이템은 제거
                    if(durTrip < this.limitMinuteTrip || durTrip === 0) {
                        if(idxTrip > 0){
                            // 현재 1번 인덱스까지
                            let idxTripPrev = idxTrip - 1;
                            let itemTripPrev = this.listTrip[idxTripPrev];
                            // 이전 휴식 종료시간을 현재 휴식 종료 시간으로
                            itemTripPrev.dtToRest = itemTripCurr.dtToRest;
                            this.listTrip.splice(idxTrip,1);
                        }else{
                            // 현재 0번 인덱스
                            // 현재 아이템을 삭제만 해도 다음 운행의 시작이 전체 운행의 시작이 된다
                            this.listTrip.splice(idxTrip,1);
                        }
                    }
                    idxTrip--;
                }
            }
            resolve();
        });
        return promise;
    }
    checkValidDrive(){
        let promise = new Promise<void>((resolve) => {
            let listPromise = [];
            if(this.listTrip){
                let sizeListTrip = this.listTrip.length;
                // 마지막 아이템은 휴식시간이 없으므로 체크하지 않는다
                let itemTripLast:DriveScheduleTrip = this.listTrip[sizeListTrip - 1];
                itemTripLast.dtToRest = itemTripLast.dtFromRest;
                if(this.listTrip.length > 1){
                    for(let a=0;a<sizeListTrip - 1;a++){
                        let itemTrip:DriveScheduleTrip = this.listTrip[a];
                        listPromise.push(itemTrip.checkValid());
                    }
                }
            }
            Promise.all(listPromise).then(() => {
                resolve();
            });
        });
        return promise;
    }
}